module.exports = __webpack_public_path__ + "static/img/hotel_state_bg.d3406020.png";